import { gql } from "@apollo/client";

export const CREATE_SETTINGS = gql`
  mutation createSettings($input: CreateSettingsInputDTO!) {
    createSettings(input: $input) {
      message
    }
  }
`;
